import vuetify from '@jaaluu/vuetify';
import { ref } from 'vue';

const NOTIFY_ME_SRS_STORAGE_KEY = 'notifyMeSrs';
const ACTION_SOUNDS_STORAGE_KEY = 'actionSounds';
const SHOW_PINYIN_STORAGE_KEY = 'showPinyin';

export default () => {
  const langSettingsOpen = ref(false);
  const levelSettingsOpen = ref(false);
  const audioVideoSettingsIsOpen = ref(false);
  const themeSettingsIsOpen = ref(false);
  const playbackRate = ref(1);
  const inDarkTheme = ref(false);
  const inFullscreen = ref(false);
  const notifyMeSrs = ref(true);
  const actionSounds = ref(true);
  const showPinyin = ref(true);
  const theme = vuetify.theme.global.current;

  const setThemeInLocalSt = () => {
    localStorage.setItem('theme', theme.value.dark ? 'dark' : 'light');
  };
  const getThemeFromLocalSt = () => {
    inDarkTheme.value = localStorage.getItem('theme') === 'dark';
    if (inDarkTheme.value) {
      vuetify.theme.global.name.value = 'darkTheme';
    }
  };

  const setTheme = () => {
    vuetify.theme.global.name.value = theme.value.dark ? 'lightTheme' : 'darkTheme';
  };

  const toggleTheme = () => {
    setTheme();
    setThemeInLocalSt();
  };

  const saveNotifyMeSrsInLocalStorage = (value: boolean) => {
    localStorage.setItem(NOTIFY_ME_SRS_STORAGE_KEY, JSON.stringify(value));
  };

  const setNotifyMeFromLocalStorage = () => {
    notifyMeSrs.value = JSON.parse(localStorage.getItem(NOTIFY_ME_SRS_STORAGE_KEY) || 'true');
  };

  const saveActionSoundsInLocalStorage = (value: boolean) => {
    localStorage.setItem(ACTION_SOUNDS_STORAGE_KEY, JSON.stringify(value));
  };

  const setActionSoundsFromLocalStorage = () => {
    actionSounds.value = JSON.parse(localStorage.getItem(ACTION_SOUNDS_STORAGE_KEY) || 'true');
  };

  const saveShowPinyinInLocalStorage = (value: boolean) => {
    localStorage.setItem(SHOW_PINYIN_STORAGE_KEY, JSON.stringify(value));
  };

  const setShowPinyinFromLocalStorage = () => {
    showPinyin.value = JSON.parse(localStorage.getItem(SHOW_PINYIN_STORAGE_KEY) || 'true');
  };

  return {
    state: {
      langSettingsOpen,
      levelSettingsOpen,
      playbackRate,
      audioVideoSettingsIsOpen,
      themeSettingsIsOpen,
      theme,
      inDarkTheme,
      inFullscreen,
      notifyMeSrs,
      actionSounds,
      showPinyin
    },
    funcs: {
      toggleTheme,
      getThemeFromLocalSt,
      saveNotifyMeSrsInLocalStorage,
      setNotifyMeFromLocalStorage,
      saveActionSoundsInLocalStorage,
      setActionSoundsFromLocalStorage,
      saveShowPinyinInLocalStorage,
      setShowPinyinFromLocalStorage
    }
  };
};
